import {Connection} from "@/modules/Rhizome/interfaces/connection.interface";

export namespace Film {
  export interface IFilmResponse {
    id: string;
    title: string;
    title_sort_value: string;
    image: {
      thumbnail: string;
      large: string;
    }
    video?: string;
    director: string;
    year: string;
    year_display_value?: string;
    video_start?: number | null;
    loop_start?: number | null;
    loop_end?: number | null;
    related_films: Connection.IConnectionResponse[];
  }

  export interface IFilm {
    id: number;
    title: string;
    titleSort?: string;
    description: string;
    imgPreview: string;
    imgLarge: string;
    video?: string;
    year?: number;
    year_display_value?: number;
    video_start?: number | null;
    loop_start?: number | null;
    loop_end?: number | null;
    connectionWith?: Connection.IConnectionLine[];
    keywords?: IKeyword[];
  }

  export interface IKeyword {
    id: number;
    value: string;
  }

  export interface IFilmCloud extends IFilm {
    originalPosition: {
      x: number;
      y: number;
    };
    originalCenter: {
      x: number;
      y: number;
    };
    activeSidesCoords: {
      leftX: number;
      rightX: number;
      topY: number;
      bottomY: number;
    };
    scaledSize: {
      width: number;
      height: number;
    };
    refDomElement: any;
  }

  export enum FilmState {
    DEFAULT = 'default',
    HOVERED = 'hovered',
    ACTIVE = 'active',
    INACTIVATED = 'inactivated',
    CONNECTED_WITH = 'connected-with',
  }

  const baseUrl = process.env.VUE_APP_PUBLIC_URL;
}
